import { useMemo } from 'react';
import { MenuItem, Select, Typography } from 'seagull';
import { defaultWidth } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const isTrueValue = value => value === 'true' || value === true;
const compareValues = (value1, value2) => isTrueValue(value1) === isTrueValue(value2);
export function CoverCreditCardFeesSelector(props) {
  const {
    value,
    className,
    vendorBusinessName,
    clientBusinessName,
    testid,
    width = defaultWidth,
    disabled,
    onChange,
    onOpen
  } = props;
  const valueToText = useMemo(() => ({
    true: vendorBusinessName || 'The service provider',
    false: clientBusinessName || 'The client'
  }), [clientBusinessName, vendorBusinessName]);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(Typography, {
      children: "Define who will pay the credit card processing fee"
    }), /*#__PURE__*/_jsx(Select, {
      collapseHelperText: false,
      style: {
        marginBlockStart: 8
      },
      value: value,
      displayValue: valueToText[value.toString()],
      isSelected: (itemValue, currentValue) => compareValues(currentValue, itemValue),
      testid: testid && "".concat(testid, "-dropdown"),
      width: width,
      disabled: disabled,
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(e => onChange(isTrueValue(e.target.value))),
      onClick: onOpen,
      children: ['false', 'true'].map((value, idx) => /*#__PURE__*/_jsx(MenuItem, {
        value: value,
        "data-testid": testid && "".concat(testid, "-option-").concat(idx),
        children: valueToText[value]
      }, value))
    })]
  });
}